<template>
  <div class="modal-window" @dragenter.prevent="dragEnter" @dragleave.prevent="dragLeave" @dragend.prevent="dragEnd">
    <div class="container-fluid">
      <slot name="dropzone"></slot>
      <div class="row">
        <div :class="mainClass">
          <div class="row">
            <div class="col-12" :class="modalPaddings">
              <slot>PUT CONTENT HERE</slot>
            </div>
          </div>
        </div>

        <div class="sidebar pt-4 pb-3" :class="sideBarClass">
          <slot name="sidebar"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';

  @Component({})
  export default class ModalWindow extends Vue {
    @Prop() mainWidth: number;
    @Prop() paddings: string;

    dragEnter(e) {
      e.preventDefault();
      this.$emit('dragenter', e);
    }

    dragLeave(e) {
      e.preventDefault();
      this.$emit('dragleave', e);
    }

    dragEnd(e) {
      e.preventDefault();
      this.$emit('dragend', e);
    }
    
    get mainClass(): string {
      if (this.mainWidth) {
        return 'col-' + this.mainWidth.toString();
      }

      return 'col-9';
    }

    get sideBarClass(): string {
      if (this.mainWidth) {
        return 'col-' + (12 - this.mainWidth).toString();
      }

      return 'col-3';
    }

    get modalPaddings() {
      return this.paddings || 'p-4 pl-5';
    }
  }
</script>

<style lang="scss">
  .modal-window {
    background: #f4f4f7;
    padding: 0;

    h1,
    h2 {
      font-size: 1.3rem;
      font-weight: bold;
    }

    .sidebar {
      background-color: lighten(#d8d8d8, 5%);
      margin-right: 0;
    }

    .label {
      font-weight: 600;
      color: #888 !important;
      text-transform: uppercase;
      margin-bottom: 8px !important;
    }
  }
</style>
